import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.css';

const Design = ({
  id,
  design,
  className,
  slidingTextsClassName
}) => {
  return (
    <>
      <div
        id={id}
        className={`${className} ${styles.mainText} ${styles.designWrapper}`}>
        {/* main text */}
        <div className={styles.goodDesign}>{design.mainText}</div>
        {/* scrolling text */}
        <div className={`${slidingTextsClassName} ${styles.designDescription}`}>
          {design.words && design.words.map((word, index) =>
            <div
              id={word.id}
              key={index}
              style={{ opacity: index !== 0 ? 0.25 : 1 }}
              className={styles.word}>{word.item}</div>
          )}
        </div>
      </div>
    </>
  );
};

Design.propTypes = {
  id: PropTypes.string,
  slidingTextsClassName: PropTypes.string,
  className: PropTypes.string,
  design: PropTypes.object
}

export default Design;